import React from "react";

const Facebook = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="logo-facebook">
                <path
                    id="Vector"
                    d="M15.4107 13.268L15.8768 9.67558H12.9589V7.34459C12.9589 6.36158 13.3661 5.40388 14.6732 5.40388H16V2.34513C16 2.34513 14.7964 2.10254 13.6446 2.10254C11.2429 2.10254 9.67143 3.82176 9.67143 6.93747V9.67558H7V13.268H9.67143V21.9506C10.2071 22.0498 10.7553 22.1025 11.3143 22.1025C11.8732 22.1025 12.4214 22.0498 12.9572 21.9506V13.268H15.4072H15.4107Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="1.33"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Facebook;
